const mockData = {
  navLinks: [
    { href: '#recursos', label: 'Recursos' },
    { href: '#como-funciona', label: 'Como funciona' },
    { href: '#depoimentos', label: 'Depoimentos' },
    { href: '#faq', label: 'FAQ' },
    { href: '#planos', label: 'Planos' },
  ],
  badge: '+24 milhoes apostam - 1 em cada 5 perde o controle',
  hero: {
    headline: 'Bloqueamos bets com',
    highlight: 'Inteligencia Artificial',
    subheadline: 'O Anjora usa IA para interceptar anuncios e pesquisas de apostas em todo o seu celular - Google, Instagram, Facebook, TikTok e YouTube. Sem VPN, sem proxy.',
  },
  ctaPrimary: 'Testar 14 dias gratis',
  ctaSecondary: 'Ver como funciona',
  features: [
    {
      id: 'google',
      icon: 'Search',
      tag: 'IA On-Device',
      title: 'Bloqueamos a pesquisa, não só o site',
      badge: 'IA On-Device',
      accentFrom: '#06b6d4',
      accentTo: '#0ea5e9',
      description:
        'Anjora intercepta pesquisas de bets e jogos de azar direto na busca do Google. A IA identifica a intenção da pesquisa e bloqueia antes mesmo dos resultados aparecerem - cortando o impulso na raiz.',
      cta: 'Ativar Proteção',
    },
    {
      id: 'social',
      icon: 'Shield',
      tag: 'Proteção Total',
      title: 'Redes sociais sem armadilhas',
      badge: 'Proteção Total',
      accentFrom: '#8b5cf6',
      accentTo: '#6366f1',
      description:
        'Instagram, Facebook, TikTok, YouTube e Telegram. Quando você clica em um link patrocinado de aposta, o Anjora identifica e te tira da página antes mesmo dela carregar por completo.',
      cta: 'Ver na prática',
    },
    {
      id: 'consciencia',
      icon: 'BarChart3',
      tag: 'Dashboard',
      title: 'Veja quantas armadilhas você venceu',
      badge: 'Dashboard',
      accentFrom: '#14b8a6',
      accentTo: '#10b981',
      description:
        'O app mostra a quantidade de bloqueios do dia, da semana e do mês - separados por origem (Google, Instagram, Facebook, etc). Sem expor URLs específicas, apenas a contagem, criando consciência sobre a constância das tentativas.',
      cta: 'Ver painel',
    },
  ],
  stats: [
    { value: '50K+', label: 'Ja protegidos pelo Anjora' },
    { value: '2M+', label: 'Bloqueios realizados' },
    { value: '4.8', label: 'Nota na Play Store' },
  ],
  faqs: [
    {
      q: 'O que torna o Anjora diferente de outros bloqueadores?',
      a: 'Somos o primeiro app brasileiro a usar Inteligencia Artificial para bloquear pesquisas de apostas e jogos de azar diretamente na busca do Google - nao apenas os sites finais. A IA analisa a intencao da pesquisa em tempo real e intercepta antes que os resultados sejam exibidos.',
    },
    {
      q: 'Como o Anjora bloqueia as apostas?',
      a: 'Quando voce digita termos relacionados a apostas (nomes de bets, "aposta esportiva", "jogo do tigrinho", etc.), nossa IA detecta a intencao e bloqueia o resultado antes mesmo de carregar. Funciona tambem ao clicar em links patrocinados de bets nas redes sociais.',
    },
    {
      q: 'O Anjora usa VPN ou muda meu DNS?',
      a: 'Nao. O Anjora nao usa VPN, nao muda DNS e nao roteia seu trafego por servidores externos. Toda a deteccao acontece localmente no seu celular atraves de um servico de acessibilidade do Android com IA on-device. Sua privacidade e velocidade de internet permanecem intactas.',
    },
    {
      q: 'O app bloqueia sites de noticias esportivas e eventos?',
      a: 'Nao. A IA do Anjora foi treinada para diferenciar casas de apostas de portais esportivos, transmissoes de jogos, redes sociais de times e canais oficiais. Voce continua acompanhando seus times e eventos normalmente.',
    },
    {
      q: 'Posso testar antes de assinar?',
      a: 'Sim! Cadastre seu e-mail no botao "Testar 14 dias gratis" no topo do site. Voce tera acesso completo a todos os recursos por 14 dias, sem cartao de credito e sem cobranca automatica.',
    },
    {
      q: 'Quais dados o Anjora coleta?',
      a: 'Apenas a quantidade de bloqueios realizados no dia, semana e mes - separados por origem (Google, Instagram, TikTok, etc.). Nao exibimos nomes especificos de sites para nao funcionar como gatilho. O foco e mostrar o tamanho do esforco de protecao, nao o conteudo bloqueado.',
    },
    {
      q: 'O Anjora esta disponivel para iPhone?',
      a: 'O Anjora esta disponivel para Android com todos os recursos. A versao para iOS esta em desenvolvimento, com lancamento previsto em breve.',
    },
  ],
  testimonials: [
    {
      name: 'Carlos M.',
      location: 'Sao Paulo, SP',
      text: 'Toda vez que eu pesquisava algo no Google aparecia anuncio de bet. O Anjora cortou isso na raiz. Em 30 dias parei de gastar R$ 800/mes.',
      rating: 5,
    },
    {
      name: 'Ana L.',
      location: 'Rio de Janeiro, RJ',
      text: 'Meu filho estava perdendo dinheiro com apostas. Instalei o Anjora no celular dele e os bloqueios foram imediatos. Recomendo para toda familia.',
      rating: 5,
    },
    {
      name: 'Roberto S.',
      location: 'Belo Horizonte, MG',
      text: 'Ver no painel quantos bloqueios aconteceram no dia me da forca. A IA esta sempre trabalhando, mesmo enquanto eu durmo.',
      rating: 5,
    },
  ],
  pricing: [
    {
      name: 'Semanal',
      price: 'R$ 9,90',
      period: 'por semana',
      features: ['Bloqueio de pesquisas Google', 'Protecao redes sociais', 'Dashboard de bloqueios'],
      cta: 'Comecar agora',
      highlight: false,
    },
    {
      name: 'Mensal',
      price: 'R$ 19,90',
      period: 'por mes',
      features: ['Tudo do plano semanal', 'Suporte prioritario', 'Atualizacoes automaticas'],
      cta: 'Mais popular',
      highlight: true,
    },
    {
      name: 'Anual',
      price: 'R$ 99,00',
      period: 'por ano',
      features: ['Tudo do plano mensal', 'Economia de 58%', 'Acesso vitalicio a novos recursos'],
      cta: 'Melhor custo-beneficio',
      highlight: false,
    },
  ],
};

export const navLinks = mockData.navLinks;
export const faqs = mockData.faqs;
export const features = mockData.features;
export const stats = mockData.stats;
export const testimonials = mockData.testimonials;
export const pricing = mockData.pricing;
export const heroData = {
  badge: mockData.badge,
  ...mockData.hero,
  ctaPrimary: mockData.ctaPrimary,
  ctaSecondary: mockData.ctaSecondary,
};
export default mockData;
